export const webIntercomProviderFactory = ({
  globWindow,
}: {
  globWindow: Window;
}) => {
  const isAvailable = () => typeof globWindow.Intercom === "function";

  const boot = (obj: {
    hide_default_launcher: false;
    name?: string;
    facility?: string;
    email?: string;
    user_id?: string;
  }) => {
    if (!isAvailable()) return;
    globWindow.Intercom("boot", {
      custom_launcher_selector: "#my-custom-launcher",
      api_base: "https://api-iam.intercom.io",
      app_id: "crktr587",
      ...obj,
    });
  };

  const show = () => {
    if (!isAvailable()) return;
    globWindow.Intercom("show");
  };

  const hide = () => {
    if (!isAvailable()) return;
    globWindow.Intercom("hide");
  };

  const onShow = (cb: () => void) => {
    if (!isAvailable()) return;
    globWindow.Intercom("onShow", cb);
  };

  const onHide = (cb: () => void) => {
    if (!isAvailable()) return;
    globWindow.Intercom("onHide", cb);
  };

  const shutdown = () => {
    if (!isAvailable()) return;
    globWindow.Intercom("shutdown");
  };

  const trackEvent = (
    event: string,
    data?: { [key: string]: string | number | boolean }
  ) => {
    if (!isAvailable()) return;
    globWindow.Intercom("trackEvent", event, data);
  };

  const update = (data: {
    name?: string;
    facility?: string;
    email?: string;
    user_id?: string;
    [key: string]: any;
  }) => {
    if (!isAvailable()) return;
    (globWindow.Intercom as any)("update", data);
  };

  return { boot, shutdown, show, onShow, hide, onHide, update, trackEvent };
};
